import React, { Component } from "react";
import { Typography, Button } from "@material-ui/core";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import "./style.css";
import { StyledContent, StyledHeader } from "../../../styles";

export default class ViewTutorial extends Component {
    constructor(props) {
        super(props);
        this.state = { reportNotPresent: false };
    }
    render() {
        const { video, setModalState } = this.props;

        return (
            <Modal isOpen={video ? true : false} size="xl">
                <StyledHeader>
                    <Typography variant="headline">{video.title}</Typography>
                </StyledHeader>
                {video && (
                    <StyledContent>
                        <ModalBody>
                            <iframe
                                title="youtubevideocontainer"
                                width="100%"
                                height="400"
                                src={video.vid_url}
                                frameborder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen="true"
                            ></iframe>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                onClick={() => setModalState(false)}
                                color="primary"
                                variant="contained"
                                style={{ marginRight: 5 }}
                            >
                                Cancel
                            </Button>
                        </ModalFooter>
                    </StyledContent>
                )}
            </Modal>
        );
    }
}
